export const getCurrentColumns = (state) => {
  if (state.ui.currentTab === 'lease') {
    return state.session.currentLeaseColumns;
  } else {
    return state.session.currentSaleColumns;
  }
};
